const descriptions = {
  tabTitleLabel: {
    id: 'course-authoring.textbooks.form.tab-title.label',
    defaultMessage: 'Nombre del libro de texto',
    description: 'Label for the textbook name field in the form',
  },
  tabTitlePlaceholder: {
    id: 'course-authoring.textbooks.form.tab-title.placeholder',
    defaultMessage: 'Introducción a la elaboración de galletas',
    description: 'Placeholder text for the textbook name field in the form',
  },
  tabTitleHelperText: {
    id: 'course-authoring.textbooks.form.tab-title.helper-text',
    defaultMessage: 'Proporcione el título/nombre del libro de texto tal como le gustaría que lo vieran sus alumnos.',
    description: 'Helper text for the textbook name field in the form',
  },
  tabTitleValidationText: {
    id: 'course-authoring.textbooks.form.tab-title.validation-text',
    defaultMessage: 'Se requiere el nombre del libro de texto.',
    description: 'Validation error message for the textbook name field in the form',
  },
  chapterTitleLabel: {
    id: 'course-authoring.textbooks.form.chapter.title.label',
    defaultMessage: 'Nombre del capítulo',
    description: 'Label for the chapter name field in the form',
  },
  chapterTitlePlaceholder: {
    id: 'course-authoring.textbooks.form.chapter.title.placeholder',
    defaultMessage: 'Capítulo {value}',
    description: 'Placeholder text for the chapter name field in the form',
  },
  chapterTitleHelperText: {
    id: 'course-authoring.textbooks.form.chapter.title.helper-text',
    defaultMessage: 'Proporcione el título/nombre del capítulo que se utilizará para la navegación.',
    description: 'Helper text for the chapter name field in the form',
  },
  chapterTitleValidationText: {
    id: 'course-authoring.textbooks.form.chapter.title.validation-text',
    defaultMessage: 'Se requiere el nombre del capítulo.',
    description: 'Validation error message for the chapter name field in the form',
  },
  chapterUrlLabel: {
    id: 'course-authoring.textbooks.form.chapter.url.label',
    defaultMessage: 'Activo del capítulo',
    description: 'Label for the chapter asset field in the form',
  },
  chapterUrlPlaceholder: {
    id: 'course-authoring.textbooks.form.chapter.url.placeholder',
    defaultMessage: 'ruta/a/introducciónAHornearGalletas-CH1.pdf',
    description: 'Placeholder text for the chapter asset field in the form',
  },
  chapterUrlHelperText: {
    id: 'course-authoring.textbooks.form.chapter.url.helper-text',
    defaultMessage: 'Suba un archivo PDF o proporcione la ruta a un archivo de recursos de Studio.',
    description: 'Helper text for the chapter asset field in the form',
  },
  chapterUrlValidationText: {
    id: 'course-authoring.textbooks.form.chapter.url.validation-text',
    defaultMessage: 'Se requiere un recurso de capítulo',
    description: 'Validation error message for the chapter asset field in the form',
  },
  addChapterHelperText: {
    id: 'course-authoring.textbooks.form.add-chapter.helper-text',
    defaultMessage: 'Por favor, añade al menos un capítulo.',
    description: 'Helper text for adding a new chapter in the form',
  },
  addChapterButton: {
    id: 'course-authoring.textbooks.form.add-chapter.button',
    defaultMessage: 'Agregar un capítulo',
    description: 'Text for the button to add a new chapter in the form',
  },
  uploadButtonTooltip: {
    id: 'course-authoring.textbooks.form.upload-button.tooltip',
    defaultMessage: 'Subir',
    description: 'Tooltip text for the upload button in the form',
  },
  uploadButtonAlt: {
    id: 'course-authoring.textbooks.form.upload-button.alt',
    defaultMessage: 'botón de carga de capítulos',
    description: 'Alt text for the upload button in the form',
  },
  deleteButtonTooltip: {
    id: 'course-authoring.textbooks.form.delete-button.tooltip',
    defaultMessage: 'Borrar',
    description: 'Tooltip text for the delete button in the form',
  },
  deleteButtonAlt: {
    id: 'course-authoring.textbooks.form.delete-button.alt',
    defaultMessage: 'botón-eliminar-capítulo',
    description: 'Alt text for the delete button in the form',
  },
  cancelButton: {
    id: 'course-authoring.textbooks.form.button.cancel',
    defaultMessage: 'Cancelar',
    description: 'Text for the cancel button in the form',
  },
  saveButton: {
    id: 'course-authoring.textbooks.form.button.save',
    defaultMessage: 'Guardar',
    description: 'Text for the save button in the form',
  },
  uploadModalTitle: {
    id: 'course-authoring.textbooks.form.upload-modal.title',
    defaultMessage: 'Subir un nuevo PDF a “{courseName}”',
    description: 'Title for the upload modal in the form',
  },
  uploadModalDropzoneText: {
    id: 'course-authoring.textbooks.form.upload-modal.dropzone-text',
    defaultMessage: 'Arrastra y suelta tu archivo PDF aquí o haz clic para cargarlo.',
    description: 'Text for the dropzone in the upload modal',
  },
  uploadModalHelperText: {
    id: 'course-authoring.textbooks.form.upload-modal.help-text',
    defaultMessage: 'El archivo debe estar en formato PDF.',
    description: 'Helper text for the upload modal',
  },
  uploadModalFileInvalidSizeText: {
    id: 'course-authoring.textbooks.form.upload-modal.file-size-invalid-text',
    defaultMessage: 'El tamaño del archivo debe ser menor que {maxSize}MB.',
    description: 'Error message for invalid file size in the upload modal',
  },
};

export default descriptions;
